import type { TranslationCatalog } from "../TranslationManager";

export const sw: TranslationCatalog = {
  "labels.cardNumber": "Nambari ya kadi",
  "labels.expirationDate": "Tarehe ya kumalizika",
  "labels.cvc": "Nambari ya usalama",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Nambari ya kadi yako si sahihi.",
  "errors.invalidExpiryDate": "Tarehe ya kumalizika ya kadi yako si sahihi.",
  "errors.invalidCvc": "Nambari ya usalama ya kadi yako si sahihi.",
  "errors.incompleteCardNumber": "Nambari ya kadi yako haijakamilika.",
  "errors.incompleteExpiryDate": "Tarehe ya kumalizika ya kadi yako haijakamilika.",
  "errors.incompleteCvc": "Nambari ya usalama ya kadi yako haijakamilika.",
  "errors.expiredCard": "Kadi yako imekwisha muda wake.",
  "aria.cardNumber": "Nambari ya kadi",
  "aria.expirationDate": "Tarehe ya kumalizika",
  "aria.cvc": "Nambari ya usalama",
  "aria.cardInput": "Taarifa za kadi",
};
